module.exports = __webpack_public_path__ + "img/chr_ts_20_penlight.d56da114.png";